export default "__VITE_ASSET__88GF6hDg__"